import { createBooleanSimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/common/createBooleanSimpleFilterDefinition';

/**
 * AD Object Authentication Enabled field definition
 * Boolean field with Yes/No dropdown for authentication enabled status filtering
 */
export const ADObjectAuthenticationEnabled =
  createBooleanSimpleFilterDefinition(
    'authenticationenabled',
    'Authentication Enabled'
  );
